// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3tLVO","empty":"ModalGraph_empty__3zqh2"};